<template>
    <main-content-wrapper>
        <h1 class="text-md-center">
            POZABLJENA PIN ŠTEVILKA
            <span>Po vpisu vaše številke kartice boste skozi postopek registracije ustvarili uporabniško ime in geslo s katerim boste dostopali do vašega spletnega profila.</span>
        </h1>
        <empty-space />
        <v-layout justify-center row wrap fill-height >
            <v-flex xs12 md6 pl-5 pr-5 pt-4 pb-4 class="border">
                <v-form v-model="valid" @submit.prevent="" ref="form">
                    <v-alert
                            :value="inviteStoreOnly"
                            type="error"
                    >
                       <b>V Spletni trgovini Tuš Cash & Carry skrbimo za varnost vaših podatkov.</b>
                        <p>
                            V naši bazi ni vašega e-naslova, da bi lahko preverili vašo identiteto.
                        </p>
                        <p>
                            Pridobitev PIN številke je mogoča samo v poslovalnici. S seboj prinesite Tuš Cash & Carry klub kartico in osebni dokument.
                        </p>

                    </v-alert>
                    <v-alert
                            :value="generalError!=null"
                            type="error"
                    >
                        {{ generalError }}
                    </v-alert>
                    <h4>
                        Vpišite 13-mestno številko<br />
                        Tuš Cash & Carry klub kartice
                    </h4>
                    <card-number v-model="card" required label="Vpišite številko Tuš Cash & Carry klub" />
                </v-form>
                <v-btn depressed large block color="primary_action" @click="sendCreateAccount" :loading="loading">Pridobite vstopne podatke</v-btn>
            </v-flex>
        </v-layout>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import SplitContent from "../components/SplitContent";
    import EmptySpace from "../components/EmptySpace";
    import CardNumber from "../components/CardNumber";
    import {userService} from "../services";


    export default {
        name: "ForgotPin",
        components: {SplitContent, MainContentWrapper, EmptySpace, CardNumber},
        data: vm => ({
            card: null,
            loading: false,
            inviteStoreOnly: false,
            generalError: null
        }),
        methods: {
            sendCreateAccount(){
                let isValid = this.$refs.form.validate();
                if (isValid) {
                    this.loading = true;
                    this.inviteStoreOnly = false;
                    this.generalError = null;
                    userService.sendInvitation(this.card).then(
                        (data)=>{
                            this.$store.dispatch('application/emailSentMessage', {
                                'title': 'Na vaš e-naslov ('+data['email']+') smo poslali povezavo za potrditev registracije',
                                'text': 'Na vaš e-naslov ('+data['email']+') smo vam poslali povezavo. Za dokončanje postopka registracije morate potrditi povezavo v sporočilu.<br /><br />Za zaključek registracije PIN številke ne boste potrebovali.'
                            })
                        },
                        (error) => {
                            if (error.error_code == 14){
                                this.inviteStoreOnly = true;
                            } else {
                                this.generalError = error.message;
                            }
                    }).finally(()=>{
                        this.loading = false;
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>